import { isDevMode } from './env'

// IP
// HOST = 'https://insure.meteo.yiring.com'
// HOST = 'http://10.111.102.40:8081'
// HOST = 'http://10.111.102.46:8081'
// HOST = 'http://10.111.102.37:8089'杨
// HOST = 'http://113.247.231.116:49010'
// http://192.168.173.78:39898 测试

// const API_GIS = 'http://192.168.173.49:1234' // 192.168.173.49:1234
// const API_STATIC = 'http://192.168.173.78:8088/minio'
// const API_JSON = 'http://192.168.173.78:8088/minio/public'

// const API_GIS = 'https://insure.meteo.yiring.com/gis/'
// const API_STATIC = 'https://test.insure.meteo.yiring.com/minio'
// const API_JSON = 'https://test.insure.meteo.yiring.com/minio/public'

/**
 * 通过host判断版本
 * @returns
 */
export function getVersionByHost() {
    return window.location.host?.includes('highway')
}

// const netWork = 'https://test.insure.meteo.yiring.com'
const netWork = 'https://insure.meteo.yiring.com'
// const netWork = 'http://10.111.128.152:8585'

// 开发环境默认地址
enum localUrl {
    /**
     * 默认 API 地址
     */

    API_URL = netWork,

    /**
     * 静态文件地址minio
     */
    API_STATIC = `${netWork}/minio`,

    /**
     *  项目地图地址
     */
    API_GIS = `${netWork}/gis`,

    /**
     * json地址
     */
    API_JSON = `${netWork}/minio/public`,
}

/* ************ 生产环境 tip: 不要修改 动态拆分环境。*******************/
// [0:正式环境，1:测试环境]
const Host_formal = 'https://insure.meteo.yiring.com'
const Host_test = 'https://test.insure.meteo.yiring.com'
const Host_new = 'https://hnpicc.hntianxin.com'

enum URL {
    /**
     * 默认 API 地址
     */
    // @ts-expect-error
    API_URL = [`${Host_formal}`, `${Host_test}`],

    /**
     * 静态文件地址
     */
    // @ts-expect-error
    API_STATIC = [`${Host_formal}/minio`, `${Host_test}/minio`],

    /**
     * 项目地图地址
     */
    // @ts-expect-error
    API_GIS = [`${Host_formal}/gis/`, `${Host_test}/gis`],

    /**
     * json地址
     */
    // @ts-expect-error
    API_JSON = [`${Host_formal}/minio/public`, `${Host_test}/minio/public`],
}

/**
 * 构建URL
 * @return
 * s
 */
export const isInternal =
    typeof window !== 'undefined' && /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(window.location.hostname)

// 是否是内网
function buildURLAPI() {
    const URL_PREFIX = '/api'

    function getUrl(urlKey) {
        if (isDevMode()) {
            return localUrl?.[urlKey]
        }
        if (isInternal) {
            if (urlKey === 'API_URL') return 'http://192.168.173.47:12121'
            if (urlKey === 'API_STATIC') return 'http://192.168.173.48:18100'
            if (urlKey === 'API_GIS') return 'http://192.168.173.49:1234'
            if (urlKey === 'API_JSON') return 'http://192.168.173.48:18100/public'
        }
        // 外网区分：域名包含 yiring 走老的外网，否则走新域名 hnpicc.hntianxin.com
        if (window.location.hostname.includes('yiring')) {
            return URL?.[urlKey]?.[isTest() ? 1 : 0]
        }
        // 新域名
        if (urlKey === 'API_URL') return Host_new
        if (urlKey === 'API_STATIC') return `${Host_new}/minio`
        if (urlKey === 'API_GIS') return `${Host_new}/gis`
        if (urlKey === 'API_JSON') return `${Host_new}/minio/public`
        return undefined
    }

    return {
        API_URL: getUrl(`API_URL`),
        API_URL_PREFIX: URL_PREFIX,
        API_STATIC: getUrl(`API_STATIC`),
        API_GIS: getUrl(`API_GIS`),
        API_JSON: getUrl(`API_JSON`),
        API_MAP: getUrl(`API_MAP`),
    }
}

/**
 * 是否是测试版本
 */
function isTest() {
    return false // window?.location?.host?.includes('test')
}

const { API_URL, API_URL_PREFIX, API_STATIC, API_GIS, API_JSON } = buildURLAPI()

export {
    /**
     * API URL
     * eg: https://beta.app.yiring.com
     */
    API_URL,
    /**
     * API URL Prefix
     * eg: /api
     */
    API_URL_PREFIX,

    /**
     * 静态文件地址
     */
    API_STATIC,

    /**
     *  地图瓦片地址
     */
    API_GIS,

    /**
     *  后端返回的json文件地址
     */
    API_JSON,
}
